import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";

import * as Regex from 'utils/validations';
import { DataContext } from 'providers/data';
import { ParamsDataCustomerForEdit } from 'utils/typeServices';

import { Box } from '@mui/material';

import Input from 'components/views/form/Input';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import { Label } from '../styles';

type ParamsCustomerForEdit = {
    dataCustomerForEdit: ParamsDataCustomerForEdit;
}

const TopicsEdit = ({ dataCustomerForEdit }: ParamsCustomerForEdit) => {
    const [dateBith, setDateBith] = useState('');
    const { register, setValue, watch } = useForm();
    const [isEditInfos, setIsEditInfos] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const { handlePostEditCustomerAppData } = useContext(DataContext);

    const handleDefault = () => {
        setIsLoading(false);
        setIsEditInfos(false);
        setValue('email', dataCustomerForEdit.email);
    }

    const handlePostEditCustomerAppDataState = () => {
        setIsLoading(true);
        handlePostEditCustomerAppData({
            token: localStorage.getItem('token')!,
            body: {
                id: dataCustomerForEdit.id,
                email: email,
                name: dataCustomerForEdit.name,
                userAlias: dataCustomerForEdit.user.username,
                document: dataCustomerForEdit.document,
                birthDate: dataCustomerForEdit.birthDate,
            }
        })
    }

    const email = watch('email');

    useEffect(() => {
        if (dataCustomerForEdit) {
            setIsLoading(false);
            setIsEditInfos(false);
            const date = dataCustomerForEdit?.birthDate?.split('T')[0];
            setValue('email', dataCustomerForEdit.email);
            date && setDateBith(`${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataCustomerForEdit]);

    return (
        <Box sx={{ width: '100%', '#box-input': { maxWidth: '21.875rem' } }}>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: '1.1875rem', md: '3.375rem' }, marginBottom: '1.3125rem' }}>
                <Label>
                    <p className='title'>
                        Nome completo
                    </p>
                    <p className='description'>
                        {dataCustomerForEdit.name}
                    </p>
                </Label>
                <Box sx={{ display: 'flex', justifyContent: 'start', gap: '3.375rem' }}>
                    <Label>
                        <p className='title'>
                            Documento
                        </p>
                        <p className='description'>
                            {dataCustomerForEdit.document}
                        </p>
                    </Label>
                    <Label>
                        <p className='title'>
                            Data de Nascimento
                        </p>
                        <p className='description'>
                            {dateBith}
                        </p>
                    </Label>
                </Box>
            </Box>
            <Input
                name='email'
                label='E-mail'
                type='text'
                placeholder={email}
                disabled={!isEditInfos}
                register={{ ...register("email", { pattern: Regex.email }) }}
            />
            <Box sx={{ display: 'flex', gap: '1rem', 'button': { height: '2.5rem', width: '100%', maxWidth: { xs: '100%', md: '15.06rem' } } }}>
                <ButtonOutlined name={isEditInfos ? 'CANCELAR' : 'Editar'} onClick={() => isEditInfos ? handleDefault() : setIsEditInfos(!isEditInfos)} />

                {isEditInfos &&
                    <ButtonRectangle name='SALVAR DADOS' disabled={!email?.match(Regex.email)} loadingBtn={isLoading} onClick={() => handlePostEditCustomerAppDataState()} />
                }
            </Box>
        </Box>
    );
}

export default TopicsEdit;